import { companyInfo, navLinks } from "../data/mock";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      className="relative w-full"
      style={{
        background: "#0B0E1E",
        borderTop: "1px solid rgba(123,104,238,0.1)",
        padding: "80px 7.6923% 40px",
      }}
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Top */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div
                className="w-10 h-10 flex items-center justify-center rounded-lg"
                style={{ background: "linear-gradient(135deg, #7B68EE, #5B4BD6)" }}
              >
                <span
                  className="text-white font-bold text-lg"
                  style={{ fontFamily: "'Kode Mono', monospace" }}
                >
                  M
                </span>
              </div>
              <span
                className="font-semibold text-xl"
                style={{ fontFamily: "'Kode Mono', monospace", letterSpacing: "-0.02em", color: "#F0F0FF" }}
              >
                {companyInfo.name}
              </span>
            </div>
            <p
              style={{
                fontFamily: "'Kode Mono', monospace",
                fontSize: "14px",
                color: "#6B6B8D",
                lineHeight: 1.7,
                maxWidth: "320px",
              }}
            >
              {companyInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="mb-6"
              style={{
                fontFamily: "'Kode Mono', monospace",
                fontSize: "13px",
                fontWeight: 600,
                color: "#6B6B8D",
                textTransform: "uppercase",
                letterSpacing: "0.15em",
              }}
            >
              Navigation
            </h4>
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="bg-transparent border-none cursor-pointer text-left flex items-center gap-2 group"
                  style={{
                    fontFamily: "'Kode Mono', monospace",
                    fontSize: "15px",
                    color: "#8585A8",
                    transition: "color 0.3s ease",
                    padding: 0,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#C4B5FD";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#8585A8";
                  }}
                >
                  {link.label}
                  <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </button>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="mb-6"
              style={{
                fontFamily: "'Kode Mono', monospace",
                fontSize: "13px",
                fontWeight: 600,
                color: "#6B6B8D",
                textTransform: "uppercase",
                letterSpacing: "0.15em",
              }}
            >
              Contact
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href={`mailto:${companyInfo.email}`}
                className="no-underline"
                style={{
                  fontFamily: "'Kode Mono', monospace",
                  fontSize: "15px",
                  color: "#8585A8",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#A78BFA";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#8585A8";
                }}
              >
                {companyInfo.email}
              </a>
              {companyInfo.phones.map((phone) => (
                <a
                  key={phone}
                  href={`tel:${phone.replace(/\s/g, "")}`}
                  className="no-underline"
                  style={{
                    fontFamily: "'Kode Mono', monospace",
                    fontSize: "15px",
                    color: "#8585A8",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#A78BFA";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#8585A8";
                  }}
                >
                  {phone}
                </a>
              ))}
              <p
                style={{
                  fontFamily: "'Kode Mono', monospace",
                  fontSize: "14px",
                  color: "#6B6B8D",
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                {companyInfo.address}
              </p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-[1px] mb-8" style={{ background: "rgba(123,104,238,0.08)" }} />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            style={{
              fontFamily: "'Kode Mono', monospace",
              fontSize: "13px",
              color: "#6B6B8D",
              margin: 0,
            }}
          >
            &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <p
            style={{
              fontFamily: "'Kode Mono', monospace",
              fontSize: "13px",
              color: "#6B6B8D",
              margin: 0,
            }}
          >
            Muscat, Oman
          </p>
        </div>
      </div>
    </footer>
  );
};
